import React from 'react';
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
} from '@headlessui/react';
import {
  TemplateTerm,
  useTemplateStore,
} from '@core/template/useTemplateStore';

interface UnassignWorkerModalProps {
  workerFullName: string;
  isOpen: boolean;
  onClose: () => void;
  onUnassignWorker: () => void;
}

const UnassignWorkerModal = ({
  workerFullName,
  isOpen,
  onClose,
  onUnassignWorker,
}: UnassignWorkerModalProps) => {
  const { getTerm } = useTemplateStore();

  return (
    <Transition show={isOpen} as={React.Fragment}>
      <Dialog as="div" className="relative z-60" onClose={onClose}>
        <Transition.Child
          as={React.Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto pt-15">
          <div className="flex min-h-full items-center justify-center p-4">
            <Transition.Child
              as={React.Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <DialogPanel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white px-6 py-12 text-left align-middle shadow-xl transition-all">
                <DialogTitle
                  as="h3"
                  className="flex justify-center text-lg leading-6 font-medium text-gray-900"
                >
                  {`Do you want to unassign ${workerFullName}?`}
                </DialogTitle>
                <div className="mt-2 mb-5 flex flex-col items-center justify-center gap-3">
                  <p className="text-sm text-gray-500">
                    The job will be reposted.
                  </p>
                  <p className="text-sm text-gray-500">
                    The {getTerm(TemplateTerm.WORKER, false)} will be no longer
                    be able to apply for this job.
                  </p>
                </div>

                <div className="mt-4 flex justify-center gap-2">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-gray-100 px-4 py-2 text-sm font-medium text-gray-900"
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md border border-transparent bg-blue-900 px-4 py-2 text-sm font-medium text-white"
                    onClick={() => {
                      onUnassignWorker();
                      onClose();
                    }}
                  >
                    Unassign
                  </button>
                </div>
              </DialogPanel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default UnassignWorkerModal;
